'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.LandSchema = {
  title: 'Land',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/land.js
// module id = BoCu
// module chunks = 0